export default {"src":"/_next/static/media/mfone-gl-landing1.29283381.svg","height":20,"width":26,"blurWidth":0,"blurHeight":0};